import React, { useState, useEffect } from "react";
import MyTable from "../../components/Schedule/MyTable";
import { Grid, Typography, Box, Button, Paper, Checkbox } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ApiService from "../../functions/apiService";
import Modal from 'react-bootstrap/Modal';
import { Col, Row } from 'react-bootstrap';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import AddCerificateEmployee from "./AddCertificateEmployee";
import CalendarLoader from "../../components/Calendar/CalendarLoader";
import { Link, useNavigate, useParams } from "react-router-dom";
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';

const CertificateMembers = (props) => {
  let { id } = useParams();
  const [data, setData] = useState([])
  const [deletModal, setDeleteModal] = useState(false)
  const [deleteId, setDeleteId] = useState('')
  const [addModal, setAddModal] = useState(false)
  const [editId, setEditId] = useState('')
  const [loading, setLoading] = useState(false);
  const [selectedEmp, setSelectedEmp] = useState([])
  const [expModal, setExpModal] = useState(false)
  const [date, setDate] = useState(new Date())
  const [noExpiry, setNoExpiry] = useState(false)
  const [isMultiDelete, setIsMultiDelete] = useState(false)

  const columns = [
    {
      field: 'name', headerName: 'Certificate Name', flex: 1, minWidth: 200
      , valueGetter: (params) => params.row.certificate.Name
    },
    {
      field: 'fullName', headerName: 'Name', flex: 1, minWidth: 200
      , valueGetter: (params) => params.row.employee_assignment?.EA_Rank + ' ' + params.row.employee?.fullName
    },
    {
      field: 'expiryDate', headerName: 'Expiry Date', flex: 1, minWidth: 120
      , valueGetter: (params) => params.row.Expiration_Date ? moment(params?.row?.Expiration_Date).format('MM/DD/YY') : 'No Expiry'
    },
    {
      field: 'trainingHistory', headerName: 'Training History', flex: 1, minWidth: 120
      , valueGetter: (params) => params.row.Training_History
    },
    {
      field: 'inDayShift', headerName: 'Action', flex: 1, minWidth: 120,
      renderCell: (params) => {
        return (
          <div style={{ gap: 10, display: 'flex' }}>
            <img src='/images/edit.svg' style={{ cursor: 'pointer' }} onClick={() => {
              setEditId(params?.row?.Emp_Code)
              setAddModal(true)
            }} />
            <img src='/images/delete.svg' style={{ cursor: 'pointer' }} onClick={() => {
              setDeleteId(params?.row?.Emp_Code)
              setDeleteModal(true)
              setIsMultiDelete(false)
            }} />
          </div>
        );
      }
    },
  ]

  const certificateData = () => {
    if (id) {
      setLoading(true)
      ApiService.get('/certificate-employees/' + id)
        .then(({ data }) => {
          setData(data?.data)
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }

  let onRowSelectionModelChange = (newSelection) => {
    setSelectedEmp(newSelection)
  }

  const deleteUser = () => {
    setLoading(true)
    ApiService.get(`/delete-certificate-employee/${id}/${deleteId}`)
      .then(({ data }) => {
        setDeleteId('')
        setDeleteModal(false)
        toast.success(data.message)
        certificateData()
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        toast.error(err?.response?.data?.message)
      })
  }

  const deleteMultiUser = () => {
    const body = {
      "Certificate_id": id,
      "Emp_Codes": selectedEmp
    }
    setLoading(true)
    ApiService.post('/delete-multiple-certificate-employees', body)
      .then((data) => {
        setDeleteModal(false)
        setIsMultiDelete(false)
        setSelectedEmp([])
        toast.success(data.message)
        certificateData()
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        if (error.status == 422) {
          Object.keys(error.data.errors).map((err) => (
            toast.error(error.data.errors[err][0])
          ))
        }
        else {
          toast.error(error.data.message)
        }
      })
  }

  const editExpiry = () => {
    const body = {
      "Certificate_id": id,
      "Expiration_Date": noExpiry ? null : date,
      "Emp_Codes": selectedEmp
    }
    setLoading(true)
    ApiService.post('/update-multiple-employees-certificate-expiry', body)
      .then((data) => {
        setExpModal(false)
        setLoading(false)
        certificateData()
        setSelectedEmp([])
        toast.success(data.message)
      })
      .catch((error) => {
        setLoading(false)
        if (error.status == 422) {
          Object.keys(error.data.errors).map((err) => (
            toast.error(error.data.errors[err][0])
          ))
        }
        else {
          toast.error(error.data.message)
        }
      })
  }

  useEffect(() => {
    certificateData()
  }, [])


  return (
    <>

      <Paper className="p-4" style={{ marginTop: "1rem" }}>
        <div>
          <Grid container spacing={2} alignItems="center" justifyContent="space-between">
            <Grid item xs={9}>
              <Typography variant="h5">Certification Module</Typography>
            </Grid>
          </Grid>
        </div>
        <Box>
          <Link to={`/firehouse/certificates`}>
            <Button className='text-decoration-none mt-4' style={{ color: '#555555', paddingLeft: "0px" }}>
              <ArrowBackIosIcon /> Back
            </Button>
          </Link>
        </Box>
        <div className='mt-4 d-flex' style={{ justifyContent: 'space-between' }}>
          <Grid item xs={12}>
            <Typography variant="h6">Certificate Members</Typography>
          </Grid>

          <div className='mt-4 d-flex' style={{ justifyContent: 'space-between', gap: 10 }}>
            <ButtonTheme type='submit' variant="filled" color='primary' disabled={selectedEmp.length == 0}
              onClick={() => setExpModal(true)}>
              Edit Expiry
            </ButtonTheme>
            <ButtonTheme type='submit' variant="filled" color='primary' disabled={selectedEmp.length == 0}
              onClick={() => {
                setIsMultiDelete(true)
                setDeleteModal(true)
              }}>
              Delete
            </ButtonTheme>
            <ButtonTheme type='submit' variant="filled" color='primary' onClick={() => setAddModal(true)}>
              Add certificate employee
            </ButtonTheme>
          </div>
        </div>
        {loading == true ?
          <CalendarLoader />
          :
          data?.length > 0 ? (
            <div className="hide-header-checkbox-page">
              <MyTable
                rows={data}
                columns={columns}
                perPage={10}
                rowCount={data.length}
                selectedRows={selectedEmp}
                onRowSelectionModelChange={onRowSelectionModelChange}
              />
            </div>
          ) : (
            <Box>
              <div className='inner-box'>
                <img src='/images/blur-logo.png' />
                 <div className='mt-4' style={{ color: '#555555' }}>
                 There are no members currently.
                </div>
              </div>
            </Box>
          )
        }
      </Paper>

      <Modal show={deletModal} onHide={() => {
        setDeleteModal(false)
        setIsMultiDelete(false)
        setSelectedEmp([])
      }}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Certificate User(s)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ color: '#555555' }}>
            Are you sure to delete {isMultiDelete ? 'these' : 'this'} certificate user(s)?
          </div>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' disabled variant="filled" color='primary' className='mt-4' onClick={() => {
                setDeleteModal(false)
                setIsMultiDelete(false)
                setSelectedEmp([])
              }}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
                onClick={() => { isMultiDelete ? deleteMultiUser() : deleteUser() }}>
                Delete
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal show={expModal} size="lg" onHide={() => {
        setExpModal(false)
        setSelectedEmp([])
      }}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Expiry date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='w-100' style={{ flexWrap: 'wrap' }}>
            <Col md={6} className='d-grid'>
              <label className='my-1'>Expiration Date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ButtonDatePicker
                  className='w-100'
                  label={noExpiry ? 'No expiry' : moment(date).format('MM-DD-YYYY')}
                  value={new Date(date)}
                  onChange={(e) => {
                    setDate(moment(e).format('YYYY-MM-DD'))
                    setNoExpiry(false)
                  }}
                  minDate={new Date()}
                />
              </LocalizationProvider>
              <Row>
                <Col md='auto' className='p-0'>
                  <Checkbox label={'hr'}
                    checked={noExpiry}
                    onClick={() => setNoExpiry(!noExpiry)}
                  />
                </Col>
                <Col md={8} className='p-0'>
                  <label className='mt-2'>No Expiry Date</label>
                </Col>
              </Row>
            </Col>
          </Row>
          <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={editExpiry}>
            Update
          </ButtonTheme>
        </Modal.Body>
      </Modal>

      {addModal &&
        <AddCerificateEmployee addModal={addModal} setAddModal={setAddModal} certId={id} editId={editId}
          setEditId={setEditId} certificateData={certificateData} />
      }
    </>
  )
}

export default CertificateMembers